import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import { truncate } from '../util';

class Component extends BaseComponent {
    componentWillMount() {
        this.props.requireDaily();
        this.props.requireHexagram();
        this.props.requireNumber();

        this.love_scopes = JSON.parse(this.props.scope);
        this.love_scope = this.love_scopes[this.props.sign_int];
    }

    render({ logged_in, psychic }) {
        return (
            <more-today>
                <h1 class='widget-header'>{ `More for${logged_in ? ' You' : ''} Today`}</h1>
                <hr />
                <ul>
                    {this.renderLoveScope()}
                    <li>
                        <a href={logged_in ? '/daily-number' : '#signup'} class='text-link-undecorated widget-link'>
                            <div class='icon-number-otd' />
                            <div class='interp-preview'>
                                <h2>Daily Number</h2>
                                {this.renderNumber()}
                            </div>
                        </a>
                    </li>
                    {this.renderHexagram()}
                    <li>
                        <a href='/daily-psychic-tip' class='text-link-undecorated widget-link'>
                            <div class='icon-psychic-otd' />
                            <div class='interp-preview'>
                                <h2>Psychic Tip of the Day</h2>
                                <p>
                                    <raw content={psychic} class='widget-unformat' />
                                    <span class='text-link'>read more</span>
                                </p>
                            </div>
                        </a>
                    </li>
                </ul>
            </more-today>
        );
    }

    renderLoveScope = () => {
        if (this.love_scope) {
            return (
                <li>
                    <a href={`/daily-love-horoscope/${this.props.sign_slug}`} class='text-link-undecorated widget-link'>
                        <div class='icon-daily-love' />
                        <div class='interp-preview'>
                            <h2>Daily Love Horoscope</h2>
                            <p>
                                <raw content={truncate(this.love_scope, 75)} />
                                <span class='text-link'>read more</span>
                            </p>
                        </div>
                    </a>
                </li>
            );
        }

        return null;
    }

    renderNumber = () => {
        if (this.props.number && this.props.number[0]) {
            return (
                <p>
                    <raw content={truncate(this.props.number[0], 75)} />
                    <span class='text-link'>continue</span>
                </p>
            );
        }

        return (
            <p>
                Whoops! We can’t calculate your personal daily number without your birthdate.&nbsp;
                <span class='text-link'>Sign up</span> to get your number!
            </p>
        );
    }

    renderHexagram = () => {
        if (this.props.hexagram) {
            return (
                <li>
                    <a href='/daily-hexagram' class='text-link-undecorated widget-link'>
                        <div class='icon-hexagram-otd' />
                        <div class='interp-preview'>
                            <h2>Hexagram of the Day</h2>
                            <p>
                                <raw content={truncate(this.props.hexagram.main_text, 75)} />
                                <span class='text-link'>continue</span>
                            </p>
                        </div>
                    </a>
                </li>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    number: state.number && state.number.body,
    sign_slug: state['daily-updates'] && state['daily-updates'].horoscope && state['daily-updates'].horoscope.sign_slug,
    sign_int: state.user && state.user.default_sign || 0,
    hexagram: state.user.logged_in
        ? state.hexagram && state.hexagram.you
        : state.hexagram && state.hexagram.everyone,
});

const mapDispatchToProps = (dispatch) => ({
    requireDaily: () => dispatch({ type: 'daily-updates:required'}),
    requireHexagram: () => dispatch({ type: 'hexagram:required'}),
    requireNumber: () => dispatch({ type: 'number:required' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/more-today.js